import classNames from 'classnames'

import { usePriceColor } from '@pages/Trade/hooks/usePriceColor'
import { getStepDecimals } from '@pages/Trade/utils/helpers'

import { SensitiveData } from '@ui/Privacy/SensitiveData'
import { Body2 } from '@ui/Typography'
import { TextColorType } from '@ui/design-system/colors/colors'

import { useFormatNumber } from '@hooks/useFormatNumber'

import { useCurrentPriceForTrade } from '../hooks/useCurrentPricesStore'
import { PortfolioTrade } from '../hooks/useDxtradePortfolioTrades'
import { TypographyLike } from '../utils/formatters'

import styles from './LivePriceCell.module.scss'

type Props = {
  trade: Pick<PortfolioTrade, 'symbol' | 'side' | 'priceIncrement'>
  priceType?: 'position' | 'order'
  TypographyComp?: TypographyLike
  autoWidth?: boolean
  prefix?: string
  color?: TextColorType
  defaultColor?: TextColorType
  sensitive?: boolean
}

export const LivePriceCell: React.FC<Props> = ({
  trade,
  priceType = 'position',
  TypographyComp = Body2,
  autoWidth = false,
  sensitive = false,
  prefix,
  color,
  defaultColor,
}) => {
  const { formatNumber } = useFormatNumber()
  const live = useCurrentPriceForTrade(trade.symbol, trade.side, priceType)

  const fractionDigits = getStepDecimals(trade.priceIncrement)
  const value =
    formatNumber(live, { minDecimalPlaces: fractionDigits, maxDecimalPlaces: fractionDigits }) ??
    '-'
  const normalizedPrefix = prefix?.trim() ?? ''
  const displayValue = value !== '-' && value !== '' ? `${normalizedPrefix}${value}` : value
  const livePriceColor = usePriceColor(live, undefined, defaultColor)
  const resolvedColor = color ?? livePriceColor

  const data = sensitive ? (
    <SensitiveData>
      <span className={classNames(styles.wrapper, { [styles.autoWidth]: autoWidth })}>
        {displayValue}
      </span>
    </SensitiveData>
  ) : (
    <span className={classNames(styles.wrapper, { [styles.autoWidth]: autoWidth })}>
      {displayValue}
    </span>
  )

  return <TypographyComp color={resolvedColor}>{data}</TypographyComp>
}
